'use client'

import type { LogoProps } from '@maestro/commerce-blocks/components/logo/logo.types'

import NextImage from 'next/image'
import { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType, TopNavigationTitle } from '@maestro/data-layer'
import { theme } from '@maestro/local/theme'
import { Link } from '@pearlconvert/ui/components/link'

export default function Logo(props: LogoProps) {
  const { source, destination } = props
  const { publish } = useEventBusContext()
  const {
    title,
    logo: { width, height },
  } = theme().site

  const handleClickLogo = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.LOGO,
    })
  }, [publish])

  const image = (
    <NextImage
      src={source}
      width={width}
      height={height}
      alt={title}
      loading="eager"
      preload
      fetchPriority="high"
    />
  )

  return destination?.length ? (
    <Link className="main__logo" href={destination} onClick={handleClickLogo}>
      {image}
    </Link>
  ) : (
    image
  )
}
